import { render } from "./XIconSolidSend.vue?vue&type=template&id=f64654b2"
import script from "./XIconSolidSend.vue?vue&type=script&lang=js"
export * from "./XIconSolidSend.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidSend.vue"]])

export default __exports__